<template>
  <div >
      <div class="r-option-place r-center-flex r-isWrap">
        <InputCustom
          :rightIcon="true"
          :withError="false"
          v-model="request.search" 
          @keyup="setTime()" 
          @keydown="clearTime()" 
          @keydown.tab="setTime()" 
          @keyup.tab="clearTime()" 
          @keypress.enter="getData()" 
          placeholder="Search . . ."
          size='md'
        >
          <template #rightIcon>
            <div class="y-inputIcon r-center-flex">
                <img :src="require('@/assets/icons/others/search.svg')" alt="search">
            </div>
          </template>
        </InputCustom>

      <SelectCustom
        :roValue="request.temp_semester"
        v-model="search.semester"
        refName="semester"
        :show="showSelect == 'semester'"
        :list="filterSemesters"
        @click="toggleShow('semester')"
        @close="closeSelect()"
        @select="selectedSemester($event)"
        @mouseleave="showSelect = null"
        size="md"
        :withError="false"
      >
        <template #autocompleteitem="props">
          {{props.data.name}} {{props.data.type}}
        </template>
      </SelectCustom>

      </div>
     

      <TableCustom 
        :columns="columns" 
        :request="request" 
        :fetchData="fetchData"
        :data="data"
        @setSortBy="setSortBy"
        @setShow="setShow" 
        @getData="getData"
        @mouseleave="popup = null"
        @togglePopup="togglePopup"
        >

        <template #index="props">
            <div class="r-isRelative">
                <div class="r-notif-place">
                    <div class="r-notif-bullet y-red-bg" v-if="props.row.unreadmessage > 0"></div>
                </div>
                {{curNumber(props.index)}}
            </div>
        </template>

        <template #user="props">
          <template v-if="role == 'mahasiswa'">
            {{props.row.lecture}} ({{props.row.npp}})
          </template>
          <template v-else>
            {{props.row.student}} ({{props.row.npm}})
          </template>
        </template>

        <template #link="props">
            <AlertCustom type="warning" v-if="!props.row.tapi_link">
              <i>Link berkas tidak tersedia</i>
            </AlertCustom>
            <ButtonCustom
                type="primary"
                @click.stop="gotoLink(props.row.tapi_link)"
                v-else
            >
                Lihat Berkas
            </ButtonCustom>
        </template>
        <template #result="props">
            {{props.row.tapi_result ? `${props.row.tapi_result} (${props.row.tapi_grade})` : '-'}}
        </template>
        <template #status="props">
            <AlertCustom :type="moduleStatus(props.row.status).type">
              {{moduleStatus(props.row.status).label}}
            </AlertCustom>
        </template>
        <template #lecture_type="props">
            {{props.row.lecture_type}} {{props.row.lecture_order}}
        </template>
        <template #tapi_class="props">
            {{props.row.tapi_type}} {{props.row.tapi_class}}
        </template>
        <template #guidance_count="props">
            {{props.row.guidance_count || 0}}
        </template>
        <template #unconfirm_guidance_count="props">
            {{props.row.unconfirm_guidance_count || 0}}
        </template>


        <template #action="props">
          <div class="r-menu">
            <img class="r-is-clickable" :src="require('@/assets/icons/others/more.svg')" @click.prevent="popup = curNumber(props.index)">
            <div class="r-menu-items" v-if="popup == curNumber(props.index)" @mouseleave="popup = -1">
                <router-link class="r-menu-item y-black-text r-center-flex" :to="{name: 'ListBimbingan', params: {tapi_lecture_id: props.row.id}, query: {...$route.query}}">Bimbingan</router-link>
                <template v-if="role != 'mahasiswa'">
                  <router-link class="r-menu-item y-black-text r-center-flex" :to="{name: 'TapiStudentListForm', params: {tapi_lecture_id: props.row.id}, query: {...$route.query}}" 
                    v-if="
                      (props.row.status == 1 && props.row.tapi_type == 'tapi1') ||
                      (props.row.status == 3 && props.row.tapi_type == 'tapi2')  
                    ">Penilaian</router-link>
                  <router-link class="r-menu-item y-black-text r-center-flex" :to="{name: 'TapiStudentListReport', params: {tapi_lecture_id: props.row.id}, query: {...$route.query}}" >Laporan Penilaian</router-link>
                </template>
            </div>
          </div>
        </template>
    </TableCustom>


  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import common from '@/mixins/function/common'
import tableMixins from '@/mixins/tableMixins'
import selectMixins from '@/mixins/selectMixins'
import {
    convertDate
} from '@/common/timeformat'
import AlertCustom from '@/components/Helper/Alert'

export default {
  mixins: [common, tableMixins, selectMixins],
  components: {
    AlertCustom,
  },
  mounted() {
    this.initData()
  },
  watch: {
    tapiType(to, from){
      if(to != from && to != null){
        this.initData()
      }
    }
  },
  computed:{
    ...mapGetters({
        data: 'tapiGuidance/getUsers',
        request: 'tapiGuidance/getRequest',
        moduleStatus: 'tapi/getModuleStatus',
        user: 'auth/getUser',
        semesters: 'semester/getSemesters',
        currentSemester: "auth/getCurrentSemester",
    }),
    tapiType(){
      return this.$route.query.type
    },
    role(){
      return this.user.role
    },
    columns(){
      const columns = [
         {
            label: 'No',
            isSortable: false,
            fieldName: 'index',
            class: "r-table-firstColumn"
        },
        {
            label: this.role == 'mahasiswa' ? 'Dosen' : 'Mahasiswa',
            isSortable: false,
            fieldName: 'user',
            class: ""
        },
      ]
      return [...columns, ...this.columnsDefault]
    },
    routeName(){
      return this.$route.name
    },
    filterSemesters(){
      if(!this.search.semester) return this.semesters
      return this.semesters.filter(row => {
        const tempRow = `${row.name} ${row.type}`
        return tempRow.toLowerCase().includes(this.search.semester.toLowerCase())
      })
    },
  },
  data: () => ({
    search: {
      semester: null
    },
 
    columnsDefault: [
        {
            label: 'Kelas',
            isSortable: false,
            fieldName: 'tapi_class',
            class: ""
        },
        {
            label: 'Link Berkas',
            isSortable: false,
            fieldName: 'link',
            class: ""
        },
        {
            label: 'Peran',
            isSortable: false,
            fieldName: 'lecture_type',
            class: ""
        },
        {
            label: 'Ttl. Bim.',
            isSortable: false,
            fieldName: 'guidance_count',
            class: ""
        },
        {
            label: 'Bimbingan',
            isSortable: false,
            fieldName: 'unconfirm_guidance_count',
            class: ""
        },
        {
            label: 'Status',
            isSortable: false,
            fieldName: 'status',
            class: ""
        },
        {
            label: 'Nilai',
            isSortable: false,
            fieldName: 'result',
            class: ""
        },
        {
            label: 'Action',
            isSortable: false,
            fieldName: 'action',
            class: "r-table-actionColumn"
        }
    ],
    
    deleteModal: false,
    modal: null,
    inputType: 'Tambahkan'
  }),
  methods:{
    ...mapActions({
      getTableData: 'tapiGuidance/getUserList',
      getCurrentSemesterData: 'auth/getCurrentSemesterData',
    }),
    openModal(type = 'Tambahkan'){
      this.modal = 'inputModal'
      this.inputType = type
    },
    async initData(){
      const type = this.tapiType || 'tapi1'
      const breadcrumb = [{
          name: `Bimbingan ${type == 'tapi1' ? 'TAPI 1' : 'TAPI 2'}`,
          link: {name: null},
          current: true
        }
      ]
      this.request.type = type
      this.setActiveTab('Tapi')
      this.setBreadCrumb(breadcrumb)
      await this.getCurrentSemesterData()
      this.selectedSemester(this.currentSemester)
    },
    resetData(){
      this.modal = null; 
      this.deleteModal = false; 
      this.resetItem()
    },
    async getData(type = 0) {
        this.fetchData = true
        if(type === 0) this.request.page = 1
        else this.request.page += type
        await this.getTableData()
        this.fetchData = false
    },
    convertDate(value){
      if(!value) return '-'
      return convertDate(value)
    },
    gotoLink(link){
        window.open(link)
    },
    async selectedSemester(selected){
      this.request.temp_semester = `${selected.name} ${selected.type}`
      this.request.semester = selected.id
      this.closeSelect()
      await this.getData()
    },
  }
};
</script>